import { render } from "./InputIconCateg.vue?vue&type=template&id=2d9bbfda&scoped=true"
import script from "./InputIconCateg.vue?vue&type=script&lang=js"
export * from "./InputIconCateg.vue?vue&type=script&lang=js"

import "./InputIconCateg.vue?vue&type=style&index=0&id=2d9bbfda&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9bbfda"]])

export default __exports__